module.exports = __webpack_public_path__ + "static/media/careers-main-bg.280e2dba.svg";